import React, { Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import CheckBox from "../../../../Button/CheckBox";
import {
  CommentTargetContainer,
  ModalLabel,
} from "../CommentModal/TargetContainer";
import { IBlackListCheck, ModalRow } from "./BlackListModal";

interface BlackListCheckRowProps {
  modalType?: string;
  check: IBlackListCheck;
  setCheck: Dispatch<SetStateAction<IBlackListCheck>>;
}

export default function BlackListCheckRow({
  modalType,
  check,
  setCheck,
}: BlackListCheckRowProps) {
  return (
    <ModalRow style={{ alignItems: "flex-start" }}>
      <ModalLabel>제한 항목</ModalLabel>

      <CommentTargetContainer>
        <CheckBoxContainer>
          <CheckBox
            checked={check.create}
            onChange={(e: { target: { checked: any } }) => {
              setCheck({
                ...check,
                create: e.target.checked,
              });
            }}
            label="파티 생성"
            disabled={modalType === "view"}
          />

          <CheckBox
            checked={check.join}
            onChange={(e: { target: { checked: any } }) => {
              setCheck({
                ...check,
                join: e.target.checked,
              });
            }}
            label="파티 가입"
            disabled={modalType === "view"}
          />

          <CheckBox
            checked={check.withdraw}
            onChange={(e: { target: { checked: any } }) => {
              setCheck({
                ...check,
                withdraw: e.target.checked,
              });
            }}
            label="인출"
            disabled={modalType === "view"}
          />

          <CheckBox
            checked={check.chat}
            onChange={(e: { target: { checked: any } }) => {
              setCheck({
                ...check,
                chat: e.target.checked,
              });
            }}
            label="채팅"
            disabled={modalType === "view"}
          />

          <CheckBox
            checked={check.withdrawCheck}
            onChange={(e: { target: { checked: any } }) => {
              setCheck({
                ...check,
                withdrawCheck: e.target.checked,
              });
            }}
            label="인출 확인 중"
            disabled={modalType === "view"}
          />
        </CheckBoxContainer>
      </CommentTargetContainer>
    </ModalRow>
  );
}

const CheckBoxContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;
